import { render, staticRenderFns } from "./AuthSendPasswordResetEmail.vue?vue&type=template&id=3c0f01d4&"
import script from "./AuthSendPasswordResetEmail.vue?vue&type=script&lang=js&"
export * from "./AuthSendPasswordResetEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports